





































import { Appointment } from '@/shared/appointments/appointment';
import { AppointmentOutcome } from '@/shared/appointments/appointment-outcome';
import { AppointmentOutcomeProduct } from '@/shared/appointments/appointment-outcome-product';
import { InstructionType } from '@/shared/instruction-type';
import { AppointmentProductType } from '@/shared/types/appointment-product-type';
import { formatCurrentDate, formatDate } from '@/shared/utilities/date-utilities';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');
const userModule = namespace('user');

@Component
export default class AppointmentOutcomeInstructedProducts extends Vue {
    @typesModule.Getter('activeAppointmentProductTypes') private appointmentProductTypes!: Array<AppointmentProductType>;
    @userModule.Getter('isInternalKeyStakeholder') public isInternalKeyStakeholder!: boolean;

    @Prop({ required: true }) private products!: Array<AppointmentOutcomeProduct>;
    @Prop({ required: true }) private appointment!: Appointment;
    @Prop({ required: false, default: false }) private isEdit!: boolean;

    private originalAppointmentOutcome: AppointmentOutcome | null = this.appointment.outcome == null ? null : { ...this.appointment.outcome, products: [...this.appointment.outcome.products] };

    private get willProducts(): Array<AppointmentOutcomeProduct> {
        return this.productByType((type) => type.isWill);
    }

    private get poaProducts(): Array<AppointmentOutcomeProduct> {
        return this.productByType((type) => type.isLpa);
    }

    private get otherProducts(): Array<AppointmentOutcomeProduct> {
        return this.productByType((type) => !type.isWill && !type.isLpa);
    }

    private productByType(callbackfn: (value: AppointmentProductType, index: number, array: Array<AppointmentProductType>) => unknown): Array<AppointmentOutcomeProduct> {
        if (this.products == null || !this.products.length) {
            return [];
        }

        const productTypeIds = this.appointmentProductTypes.filter(callbackfn).map((type) => type.id!);
        const filteredProducts = this.products.filter((product) => productTypeIds.includes(product.productTypeId));

        if (this.isInternalKeyStakeholder || !this.isEdit || this.originalAppointmentOutcome == null) {
            return filteredProducts;
        }

        const originalProductTypeIds = this.originalAppointmentOutcome.products.map((product) => product.productTypeId);
        return filteredProducts.filter((product) => originalProductTypeIds.includes(product.productTypeId));
    }

    private appointmentProductTypeDescription(product: AppointmentOutcomeProduct): string {
        const appointmentProductType = this.appointmentProductTypes.find((type) => type.id === product.productTypeId);
        return appointmentProductType == null ? '' : appointmentProductType.value;
    }

    private disableProduct(product: AppointmentOutcomeProduct): boolean {
        if (this.isInternalKeyStakeholder || !this.isEdit || this.originalAppointmentOutcome == null) {
            return false;
        }

        const originalProduct = this.originalAppointmentOutcome.products.find((p) => p.productTypeId === product.productTypeId);
        return originalProduct == null || originalProduct.instructionType === InstructionType.Instructed || originalProduct.instructionType === InstructionType.NotInstructed;
    }

    private onProductSelected(product: AppointmentOutcomeProduct): void {
        if (product.instructionType !== InstructionType.Instructed) {
            product.instructionType = InstructionType.Instructed;
            product.instructedDate = !this.isEdit && this.appointment.date != null ? formatDate(this.appointment.date, true) : formatCurrentDate(true);

            return;
        }

        const originalProduct = this.originalAppointmentOutcome == null ? null : this.originalAppointmentOutcome.products.find((p) => p.productTypeId === product.productTypeId);
        this.resetProduct(product, originalProduct == null ? InstructionType.NotInstructed : originalProduct.instructionType);
    }

    private resetProduct(product: AppointmentOutcomeProduct, instructionType: InstructionType): void {
        product.instructionType = instructionType;
        product.instructedValue = null;
        product.paymentDetails = [];

        if (instructionType !== InstructionType.NotInstructed) {
            return;
        }

        product.instructedDate = null;
    }
}
